<template>
  <CoolLightBox :items="images" :index="index" @close="$lightBox.close" />
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";

export default {
  name: "LightBox",

  components: {
    CoolLightBox,
  },

  data() {
    return {};
  },

  computed: {
    hasImage() {
      return !!this.$store.state.lightBox.image;
    },

    images() {
      if (this.hasImage) {
        return [this.$store.state.lightBox.image];
      }

      return [];
    },

    index() {
      return this.hasImage ? 0 : null;
    },
  },
};
</script>

<style scoped></style>
